module.exports = __webpack_public_path__ + "static/media/poicon21.b3cc92b0.svg";